(function () {
  'use strict';
  if (window.__lcMyDeviceInitialized) return;
  window.__lcMyDeviceInitialized = true;

  var KEY = 'laadcentrum:my-device:v1';
  var lang = (document.documentElement.lang || 'nl').toLowerCase().slice(0, 2);
  var de = lang === 'de';
  var words = de ? {
    my:'Mein Gerät', choose:'Gerät wählen', change:'Ändern', save:'Gerät speichern',
    saved:'Gespeichert', missing:'Bitte wähle dein Handy-Modell.',
    manual:'Gib dein Handy-Modell ein.',
    known:'Bitte wähle ein Modell aus der Liste.',
    compatible:'Passend für dein Gerät',
    positive:'Das Modell ist in den Produkt-Kompatibilitätstags ausdrücklich aufgeführt.',
    unconfirmed:'Keine bestätigte Passform für dein Modell',
    unconfirmedText:'Dieses Produkt nennt andere Modelle. Bitte prüfe die vollständigen Produktangaben.',
    unknown:'Modell nicht eindeutig bestätigt',
    unknownText:'Für dieses Produkt fehlt eine eindeutige Modellangabe. Prüfe die Details vor dem Kauf.',
    first:'Passt das zu deinem Modell?',
    firstText:'Wähle dein Handy für eine Prüfung anhand der Produktdaten.',
    linkCases:'Hüllen',linkGlass:'Displayschutz'
  } : {
    my:'Mijn toestel', choose:'Kies je telefoon', change:'Wijzig',
    save:'Bewaar toestel', saved:'Bewaard',
    missing:'Kies eerst jouw telefoonmodel.',
    manual:'Vul eerst je telefoonmodel in.',
    known:'Kies een model uit de lijst.',
    compatible:'Geschikt voor jouw toestel',
    positive:'Dit exacte toestelmodel staat bij de compatibiliteitsgegevens van dit product.',
    unconfirmed:'Geen bevestigde match voor jouw toestel',
    unconfirmedText:'Bij dit product staan andere modellen vermeld. Controleer de volledige productspecificaties.',
    unknown:'Geschiktheid niet bevestigd',
    unknownText:'Een exacte modelvermelding ontbreekt bij dit product. Controleer de productinformatie voordat je bestelt.',
    first:'Geschikt voor jouw toestel?',
    firstText:'Kies je telefoonmodel om de productgegevens te controleren.',
    linkCases:'Hoesjes',linkGlass:'Screenprotectors'
  };

  var models = new Map();
  var brands = {iphone:'Apple iPhone',samsung:'Samsung Galaxy',pixel:'Google Pixel',xiaomi:'Xiaomi / Redmi',oppo:'OPPO',other:de?'Andere Marke':'Ander merk'};
  var order = ['iphone','samsung','pixel','xiaomi','oppo'];
  var dialog, brandSelect, modelSelect, manualWrap, modelWrap, manualInput, hint, saveButton, clearButton, links;
  var selected = null;
  var lastTrigger = null;
  var ready = false;

  function normalize(value) {
    return typeof value === 'string'
      ? value.replace(/[\u0000-\u001f\u007f]/g,'').trim().replace(/\s+/g,' ').slice(0,85)
      : '';
  }
  function keyOf(value) { return normalize(value).toLocaleLowerCase('nl-NL'); }
  function validPath(value) {
    try {
      if (!value) return '';
      var u = new URL(value,window.location.origin);
      return u.origin === window.location.origin && u.pathname.startsWith('/collections/')
        ? u.pathname + u.search : '';
    } catch (_) { return ''; }
  }
  function readSaved() {
    try {
      var data = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!data || typeof data !== 'object') return null;
      var value = normalize(data.model);
      var brand = String(data.brand || '');
      if (value.length < 2 || value.length > 85) return null;
      if (!Object.prototype.hasOwnProperty.call(brands,brand)) brand='other';
      return {model:value,brand:brand};
    } catch (_) { return null; }
  }
  function persist(item) {
    try {
      if (item) window.localStorage.setItem(KEY,JSON.stringify(item));
      else window.localStorage.removeItem(KEY);
    } catch (_) {
      // Browsers kunnen opslag blokkeren; de keuze blijft voor deze sessie werken.
    }
  }
  function catalogue() {
    var template = document.getElementById('LCDeviceModelOptions');
    if (!template || !template.content) return;
    template.content.querySelectorAll('option[data-lcd-kind]').forEach(function (option) {
      var model = normalize(option.value);
      var key = keyOf(model);
      if (!model || !key) return;
      var group = option.getAttribute('data-lcd-brand') || 'other';
      var kind = option.getAttribute('data-lcd-kind');
      var path = validPath(option.getAttribute('data-lcd-path'));
      var entry = models.get(key) || {model:model,brand:group,casesPath:'',glassPath:''};
      if (kind === 'case' && path) entry.casesPath=path;
      if (kind === 'glass' && path) entry.glassPath=path;
      models.set(key,entry);
    });
  }
  function matchingModel() {
    return selected ? models.get(keyOf(selected.model)) : null;
  }
  function paintLinks(container,caseSelector,glassSelector) {
    if (!container) return;
    var match=matchingModel();
    var caseLink=container.querySelector(caseSelector);
    var glassLink=container.querySelector(glassSelector);
    var found=false;
    if (caseLink) {
      caseLink.hidden=!match || !match.casesPath;
      if (match && match.casesPath) {caseLink.href=match.casesPath;found=true;}
      else caseLink.removeAttribute('href');
    }
    if (glassLink) {
      glassLink.hidden=!match || !match.glassPath;
      if (match && match.glassPath) {glassLink.href=match.glassPath;found=true;}
      else glassLink.removeAttribute('href');
    }
    container.hidden=!selected || !found;
  }
  function paintProductWidgets() {
    document.querySelectorAll('[data-lcd-fit]').forEach(function (node) {
      var kind=node.getAttribute('data-lcd-kind');
      var modelsOnProduct=Array.from(node.querySelectorAll('[data-lcd-product-model]')).map(function (span) {return keyOf(span.getAttribute('data-lcd-product-model'));});
      var specific=kind==='case' || kind==='glass';
      var heading=node.querySelector('[data-lcd-fit-title]');
      var detail=node.querySelector('[data-lcd-fit-details]');
      var icon=node.querySelector('[data-lcd-fit-icon]');
      var edit=node.querySelector('[data-lcd-open]');
      // Voor universele accessoires geven wij geen automatisch 'geschikt'-label.
      if (!specific) {node.hidden=true;return;}
      node.hidden=false;
      var state='prompt',title=words.first,description=words.firstText;
      if (selected) {
        if (modelsOnProduct.indexOf(keyOf(selected.model)) !== -1) {
          state='yes';
          title=words.compatible+': '+selected.model;
          description=words.positive;
        } else if (modelsOnProduct.length) {
          state='warning';
          title=words.unconfirmed+': '+selected.model;
          description=words.unconfirmedText;
        } else {
          state='neutral';
          title=words.unknown+': '+selected.model;
          description=words.unknownText;
        }
      }
      node.setAttribute('data-lcd-status',state);
      if (heading)heading.textContent=title;
      if (detail)detail.textContent=description;
      if (icon)icon.textContent=state==='yes'?'✓':state==='warning'?'!':'?';
      if (edit) edit.textContent=selected?words.change:words.choose;
    });
  }
  function paintHeader() {
    document.querySelectorAll('[data-lcd-current-label]').forEach(function (node) {
      node.textContent=selected?selected.model:(node.getAttribute('data-lcd-empty')||words.choose);
    });
    document.querySelectorAll('[data-lcd-open]').forEach(function (button) {
      var label=selected
        ? words.my+': '+selected.model+'. '+words.change
        : words.my+': '+words.choose;
      button.setAttribute('aria-label',label);
      button.title=label;
    });
    document.querySelectorAll('[data-lcd-saved-label]').forEach(function (node) {
      node.textContent=selected?selected.model:words.choose;
    });
  }
  function paintCollection() {
    document.querySelectorAll('[data-lcd-collection-links]').forEach(function (node) {
      var current=node.querySelector('[data-lcd-collection-model]');
      if (current)current.textContent=selected?selected.model:'';
      paintLinks(node,'[data-lcd-collection-case]','[data-lcd-collection-glass]');
    });
  }
  function paintDialog() {
    if (!dialog) return;
    if (clearButton)clearButton.hidden=!selected;
    paintLinks(links,'[data-lcd-case-link]','[data-lcd-glass-link]');
  }
  function paintExplorer() {
    document.querySelectorAll('[data-lcd-explorer-saved]').forEach(function (node) {
      node.textContent=selected
        ? (de?'Dein gespeichertes Gerät: ':'Mijn bewaarde toestel: ')+selected.model
        : (de?'Speichere dein Handy für später.':'Bewaar je telefoon om later sneller te winkelen.');
    });
  }
  function paint() {
    paintHeader();
    paintProductWidgets();
    paintCollection();
    paintDialog();
    paintExplorer();
  }
  function saveModel(model,brand) {
    var clean=normalize(model);
    var group=String(brand||'other');
    if (!clean || clean.length<2) return false;
    var known=models.get(keyOf(clean));
    if (known) {
      clean=known.model;group=known.brand;
    } else if (group!=='other') {
      return false;
    }
    selected={model:clean,brand:group};
    persist(selected);
    paint();
    window.dispatchEvent(new CustomEvent('lc:device-changed',{detail:{model:clean,brand:group}}));
    return true;
  }
  function clearModel() {
    selected=null;
    persist(null);
    paint();
    window.dispatchEvent(new CustomEvent('lc:device-changed',{detail:{model:null}}));
  }
  function showHint(message,warning) {
    if (!hint)return;
    hint.textContent=message||'';
    hint.toggleAttribute('data-lcd-warning',!!warning);
  }
  function populateBrands() {
    if(!brandSelect)return;
    brandSelect.replaceChildren();
    order.forEach(function (group) {
      var total=Array.from(models.values()).filter(function (m){return m.brand===group;}).length;
      if(!total)return;
      var option=document.createElement('option');
      option.value=group;
      option.textContent=brands[group]+' ('+total+')';
      brandSelect.appendChild(option);
    });
    var other=document.createElement('option');
    other.value='other';
    other.textContent=brands.other;
    brandSelect.appendChild(other);
  }
  function populateModels(preferred) {
    if(!modelSelect||!brandSelect)return;
    var group=brandSelect.value;
    var arr=Array.from(models.values()).filter(function (m) {return m.brand===group;});
    arr.sort(function (a,b) {
      return a.model.localeCompare(b.model,de?'de':'nl',{numeric:true,sensitivity:'base'});
    });
    modelSelect.replaceChildren();
    var placeholder=document.createElement('option');
    placeholder.value='';
    placeholder.textContent=de?'Wähle dein Modell':'Kies je model';
    placeholder.disabled=true;
    placeholder.selected=true;
    modelSelect.appendChild(placeholder);
    arr.forEach(function (entry) {
      var option=document.createElement('option');
      option.value=entry.model;
      option.textContent=entry.model.replace(/^Samsung /,'');
      modelSelect.appendChild(option);
    });
    if(preferred && arr.some(function(x){return keyOf(x.model)===keyOf(preferred);})) {
      modelSelect.value=arr.find(function(x){return keyOf(x.model)===keyOf(preferred);}).model;
    }
    modelSelect.disabled=!arr.length;
  }
  function setupBrand(preferred) {
    if(!brandSelect)return;
    var manual=brandSelect.value==='other';
    if(modelWrap)modelWrap.hidden=manual;
    if(manualWrap)manualWrap.hidden=!manual;
    if(manual) {
      if(manualInput && preferred)manualInput.value=preferred;
      if(modelSelect)modelSelect.disabled=true;
    } else populateModels(preferred);
    showHint('',false);
  }
  function setupDialog() {
    dialog=document.getElementById('LCDeviceDialog');
    if(!dialog)return;
    brandSelect=dialog.querySelector('[data-lcd-brand]');
    modelSelect=dialog.querySelector('[data-lcd-model]');
    manualWrap=dialog.querySelector('[data-lcd-manual-wrap]');
    modelWrap=dialog.querySelector('[data-lcd-model-wrap]');
    manualInput=dialog.querySelector('[data-lcd-manual]');
    hint=dialog.querySelector('[data-lcd-hint]');
    saveButton=dialog.querySelector('[data-lcd-save]');
    clearButton=dialog.querySelector('[data-lcd-remove]');
    links=dialog.querySelector('[data-lcd-links]');
    populateBrands();
    if(brandSelect)brandSelect.addEventListener('change',function(){setupBrand('');});
    if(saveButton)saveButton.addEventListener('click',function(){
      var manual=brandSelect.value==='other';
      var model=manual ? manualInput.value : modelSelect.value;
      if(!normalize(model)){showHint(manual?words.manual:words.missing,true);return;}
      if(!saveModel(model,brandSelect.value)){showHint(words.known,true);return;}
      closeDialog();
    });
    if(clearButton)clearButton.addEventListener('click',function(){
      clearModel();closeDialog();
    });
    dialog.querySelectorAll('[data-lcd-close]').forEach(function(b){b.addEventListener('click',closeDialog);});
    dialog.addEventListener('click',function(event){if(event.target===dialog)closeDialog();});
    dialog.addEventListener('close',function(){
      if(lastTrigger&&lastTrigger.isConnected&&typeof lastTrigger.focus==='function')lastTrigger.focus();
      lastTrigger=null;
    });
  }
  function openDialog(trigger) {
    if(!dialog)return;
    lastTrigger=trigger||document.activeElement;
    var prefer=selected?selected.brand:(models.size?(models.values().next().value.brand):'other');
    if(!Array.from(brandSelect.options).some(function(o){return o.value===prefer;})) prefer='other';
    brandSelect.value=prefer;
    if(manualInput)manualInput.value=selected&&prefer==='other'?selected.model:'';
    setupBrand(selected&&prefer!=='other'?selected.model:'');
    paintDialog();
    if(!dialog.open) {
      if(typeof dialog.showModal==='function')dialog.showModal();
      else dialog.setAttribute('open','');
    }
    if(prefer==='other'&&manualInput)manualInput.focus();
    else if(modelSelect)modelSelect.focus();
  }
  function closeDialog() {
    if(!dialog)return;
    if(typeof dialog.close==='function'&&dialog.open)dialog.close();
    else {
      dialog.removeAttribute('open');
      if(lastTrigger&&lastTrigger.isConnected)lastTrigger.focus();
      lastTrigger=null;
    }
  }
  function hydrateExplorer(root) {
    if(!root||!selected||root.dataset.lcBound!=='true')return;
    if(root.dataset.lcdHydrated===selected.model)return;
    var form=root.querySelector('[data-lcme-form]');
    var brand=form&&form.querySelector('[data-lcme-brand]');
    var variant=form&&form.querySelector('[data-lcme-model]');
    var filter=form&&form.querySelector('[data-lcme-filter]');
    var manual=form&&form.querySelector('[data-lcme-manual]');
    if(!brand||!variant)return;
    var optionAvailable=Array.from(brand.options).some(function(o){return o.value===selected.brand;});
    brand.value=optionAvailable?selected.brand:'other';
    brand.dispatchEvent(new Event('change',{bubbles:true}));
    if(brand.value==='other') {
      if(manual) {
        manual.value=selected.model;
        manual.dispatchEvent(new Event('input',{bubbles:true}));
      }
    } else {
      if(filter)filter.value='';
      if(Array.from(variant.options).some(function(o){return keyOf(o.value)===keyOf(selected.model);})) {
        variant.value=Array.from(variant.options).find(function(o){return keyOf(o.value)===keyOf(selected.model);}).value;
        variant.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    root.dataset.lcdHydrated=selected.model;
  }
  function saveFromExplorer(button) {
    var root=button.closest('[data-lc-model-explorer]');
    if(!root)return;
    var form=root.querySelector('[data-lcme-form]');
    if(!form)return;
    var brand=form.querySelector('[data-lcme-brand]');
    var model=form.querySelector('[data-lcme-model]');
    var manual=form.querySelector('[data-lcme-manual]');
    var name=brand&&brand.value==='other'?(manual&&manual.value):(model&&model.value);
    var status=root.querySelector('[data-lcd-explorer-status]');
    if(!normalize(name)) {
      if(status)status.textContent=words.missing;
      return;
    }
    var ok=saveModel(name,brand?brand.value:'other');
    if(!ok){
      if(status)status.textContent=words.known;
      return;
    }
    if(status)status.textContent=de?'Dein Handy wurde gespeichert.':'Je toestel is bewaard.';
  }
  function init() {
    if(ready)return; ready=true;
    catalogue();
    selected=readSaved();
    setupDialog();
    paint();
    document.addEventListener('click',function(event){
      var target=event.target instanceof Element?event.target:event.target&&event.target.parentElement;
      if(!target||typeof target.closest!=='function')return;
      var trigger=target.closest('[data-lcd-open]');
      if(trigger) {event.preventDefault();openDialog(trigger);return;}
      var save=target.closest('[data-lcd-explorer-save]');
      if(save) {event.preventDefault();saveFromExplorer(save);return;}
    });
    window.addEventListener('storage',function(event){
      if(event.key!==KEY && event.key!==null)return;
      selected=readSaved();paint();
    });
    window.addEventListener('pageshow',function(){paint();});
    window.LCDeviceContext = {
      get:function(){return selected?{model:selected.model,brand:selected.brand}:null;},
      save:saveModel,
      clear:clearModel,
      open:openDialog,
      hydrateExplorer:hydrateExplorer
    };
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();